import { defineComponent as _defineComponent } from 'vue';
import { BButton } from "bootstrap-vue";
import { computed } from "vue";
import { useRoute } from "vue-router/composables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ActivityPanel',
    props: {
        title: null,
        goToAllTitle: { default: undefined },
        href: { default: undefined },
        goToOnHref: { type: Boolean, default: true }
    },
    emits: ["goToAll"],
    setup(__props, { emit }) {
        const props = __props;
        const route = useRoute();
        const hasGoToAll = computed(() => props.goToAllTitle && props.href && (props.goToOnHref || (!props.goToOnHref && route.path !== props.href)));
        return { __sfc: true, props, route, emit, hasGoToAll, BButton };
    }
});
